import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  width: 100%;
  flex-direction: column;
  margin-top: 7rem;
  margin-bottom: 5rem;
  @media (max-width: 1050px) {
    margin-top: 3rem;
    margin-bottom: 3rem;
  }
`;